<template>
    <div class="footer">
        <div class="footer-content">
            <div class="company-info">
                <img
                    class="company-logo"
                    src="@/assets/home/company_logo.png"
                    alt=""
                >
                <p>
                    <img
                        src="@/assets/home/footer_icon_tel.png"
                        alt=""
                    >
                    <span>400-123-1234</span>
                </p>
            </div>
            <div class="related-detail">
                <div class="nav-list">
                    <ul class="nav-box">
                        <li>首页</li>
                        <li>资源服务</li>
                        <li>智能应用</li>
                    </ul>
                </div>
                <div class="position-info">
                    <div class="contact-info">
                        <ul class="info-group">
                            <li>固 话 : 0911-81234567</li>
                            <li>邮 箱 : zyhjzrzy@163.com</li>
                            <li>地 址 : 陕西省西安市雁塔区科技五路数字大厦1709号</li>
                        </ul>
                    </div>
                    <div class="contact-code">
                        <div class="logo-code">
                            <img
                                src="@/assets/home/footer_weixin.png"
                                alt=""
                            >
                            <p>微信</p>
                        </div>
                        <div class="logo-code">
                            <img
                                src="@/assets/home/footer_gzh.png"
                                alt=""
                            >
                            <p>中遥公众号</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Footer",
    data() {
        return {};
    },
    components: {},
    computed: {},
    methods: {},
};
</script>
<style scoped>
ul,
li,
p {
    padding: 0;
    margin: 0;
    list-style: none;
}
.footer {
    background: #16545b;
}
.footer-content {
    width: 1200px;
    margin: auto;
    display: flex;
    justify-content: flex-start;
}
.company-info {
    box-sizing: border-box;
    border: 1px solid transparent;
    width: 360px;
    height: 342px;
    background: #13484e;
    text-align: center;
}
.company-logo {
    width: 224px;
    height: 64px;
    display: block;
    margin: auto;
    margin-top: 109px;
}
.company-info p {
    width: 224px;
    margin: auto;
    margin-top: 21px;
    text-align: left;
}
.company-info p img {
    vertical-align: middle;
}
.company-info p span {
    margin-left: 10px;
    font-size: 20px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 500;
    color: #ffffff;
    line-height: 36px;
    vertical-align: middle;
}
.related-detail {
    margin-left: 79px;
}
.nav-list {
    width: 760px;
    border-bottom: 1px solid #1e5960;
    margin-top: 79px;
}
.nav-box {
    width: 283px;
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
}
.nav-box li {
    font-size: 13px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
.position-info {
    box-sizing: border-box;
    width: 760px;
    margin-top: 40px;
    padding-right: 27px;
    display: flex;
    justify-content: space-between;
}
.info-group {
    margin-top: 63px;
}
.info-group li {
    font-size: 13px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #ffffff;
}
.info-group li:nth-of-type(2) {
    margin: 15px 0;
}
.contact-code {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.logo-code:nth-of-type(1) {
    margin-right: 31px;
}
.logo-code img{
    width: 110px;
    height:110px;
    display: block;
}
.logo-code p {
    font-size: 12px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    margin-top:18px;
}
</style>